import { all } from 'redux-saga/effects';
import decryptCrmDataWatcher from './DecryptCrmData/decryptCrmData';
import getAppointments from './GetAppointments/getAppointments';
import getClientApiLocationsWatcher from './GetClientApiLocations/getClientApiLocations';
import getClientApiSolarWatcher from './GetClientApiSolar/getClientApiSolar';
import getClientApiVerifyPotentialWatcher from './GetClientApiSolar/getClientApiVerifyPotential';
import getClientApiSlotsWatcher from './GetClientApiSlots/getClientApiSlots';
import checkSubscriptionMatchWatcher from './CheckSubscriptionMatch/checkSubscriptionMatch';
import submitClientApiBookingWatcher from './SubmitClientApiBooking/submitClientApiBooking';
import reportBookingNotConfirmableWatcher from './SubmitClientApiBooking/reportBookingNotConfirmable';
import getLeadStatusWatcher from './GetLeadStatus/getLeadStatus';
import refuseClientApiJourneyWatcher from './RefuseClientApiJourney/refuseClientApiJourney';
import reportFallThroughOutcomeWatcher from './ReportFallThroughOutcome/reportFallThroughOutcome';
import clientApiInactivityTimerWatcher from './ClientApiInactivity/clientApiInactivityTimer';
import getAutoCompleteOptions from './GetAutoCompleteOptions/getAutoCompleteOptions';
import getExternalSelectOptions from './GetExternalSelectOptions/getExternalSelectOptions';
import isDomainInternalWatcher from './IsDomainInternal/isDomainInternal';
import getLegalStatementWatcher from './LegalStatement/getLegalStatement';
import subscribeToNewsletterWatcher from './Newsletter/subscribeToNewsletter';
import getSubmissionStatusWatcher from './SubmissionStatus/getSubmissionStatus';
import validatePhone from './ValidatePhone/validatePhone';
import validatePostCode from './ValidatePostcode/validatePostcode';
import getCustomerMatchesWatcher from './getCustomerMatches/getCustomerMatches';
import prepareSupplierMatchingWatcher from './prepareSupplierMatching/prepareSupplierMatching';
import getDynamicNewsletterWatcher from './GetDynamicNewsletter/getDynamicNewsletter';
import handleAnswerQuestionSideEffectsWatcher from './handleAnswerQuestionSideEffects/handleAnswerQuestionSideEffects';
import getSupplierCardLogosWatcher from './getSupplierCardLogos/getSupplierCardLogos';
import submitSelectAndConnectWatcher from './SelectAndConnect/submitSelectAndConnect';
import getPlacePredictionsWatcher from './getPlacePredictions/getPlacePredictions';
import handleGoogleAddressSelectedWatcher from './handleGoogleAddressSelected/handleGoogleAddressSelected';
import handleZipCodeProvidedWatcher from './handleZipCodeProvided/handleZipCodeProvided';
import populateFormFieldWatcher from './populateFormField/populateFormField';
import matchingSuppliersWatcher from './matchingSuppliers/matchingSuppliers';
import matchingSupplierCountLoadingWatcher from './matchingSupplierCountLoading/matchingSupplierCountLoading';
import updateMatchConfidenceWatcher from './updateMatchConfidence/updateMatchConfidence';

function* rootSaga() {
  yield all([
    getAppointments(),
    getClientApiLocationsWatcher(),
    getClientApiSolarWatcher(),
    getClientApiVerifyPotentialWatcher(),
    getClientApiSlotsWatcher(),
    checkSubscriptionMatchWatcher(),
    submitClientApiBookingWatcher(),
    reportBookingNotConfirmableWatcher(),
    getLeadStatusWatcher(),
    refuseClientApiJourneyWatcher(),
    reportFallThroughOutcomeWatcher(),
    clientApiInactivityTimerWatcher(),
    getDynamicNewsletterWatcher(),
    getLegalStatementWatcher(),
    getSubmissionStatusWatcher(),
    getSupplierCardLogosWatcher(),
    getCustomerMatchesWatcher(),
    getPlacePredictionsWatcher(),
    prepareSupplierMatchingWatcher(),
    validatePhone(),
    validatePostCode(),
    getAutoCompleteOptions(),
    getExternalSelectOptions(),
    decryptCrmDataWatcher(),
    subscribeToNewsletterWatcher(),
    isDomainInternalWatcher(),
    handleAnswerQuestionSideEffectsWatcher(),
    submitSelectAndConnectWatcher(),
    handleGoogleAddressSelectedWatcher(),
    handleZipCodeProvidedWatcher(),
    populateFormFieldWatcher(),
    matchingSuppliersWatcher(),
    matchingSupplierCountLoadingWatcher(),
    updateMatchConfidenceWatcher(),
  ]);
}

export default rootSaga;
